import styled, { createGlobalStyle } from 'styled-components';
import { Card, Button } from 'antd';

export const MediaPreviewModalStyle = createGlobalStyle`
  .media-preview-modal video::-webkit-media-controls-fullscreen-button {
    display: none;
  }
  .media-preview-modal .ant-modal-content {
    padding: 0 !important;
    border-radius: 12px;
    overflow: visible;
    position: relative;
  }
  .media-preview-modal .ant-modal-body {
    padding: 0 !important;
    border-radius: 12px;
    overflow: hidden;
  }
  .media-preview-modal .ant-modal-header {
    display: none !important;
  }
  .media-preview-modal .ant-modal-close {
    top: -14px !important;
    right: -14px !important;
    inset-inline-end: -14px !important;
    width: 30px !important;
    height: 30px !important;
    border-radius: 50% !important;
    background: #fff !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 10 !important;
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
    color: #333 !important;
  }
  .media-preview-modal .ant-modal-close:hover {
    background: #f0f0f0 !important;
    color: #000 !important;
  }
  @media (max-width: 768px) {
    .media-preview-modal {
      max-width: calc(100vw - 32px) !important;
      top: 20px !important;
      padding-bottom: 20px !important;
    }
    .media-preview-modal .ant-modal-close {
      top: -10px !important;
      right: -10px !important;
      inset-inline-end: -10px !important;
      width: 28px !important;
      height: 28px !important;
    }
    .media-preview-modal .ant-modal-body iframe {
      height: 50vh !important;
    }
  }
`;

// Background SVG - rounded container with pattern (1400x852)
const backgroundSVG = "/images/purespectrum-landing.svg";

export const LandingPageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0;
`;

// Background container covering whole screen with rounded corners
export const BackgroundContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  background-image: url(${backgroundSVG});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 30px;
  overflow: hidden;
  z-index: 0;
  
  @media (max-width: 768px) {
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    width: calc(100vw - 30px);
    height: calc(100vh - 30px);
    border-radius: 20px;
  }
  
  @media (max-width: 480px) {
    top: 10px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    width: calc(100vw - 20px);
    height: calc(100vh - 20px);
    border-radius: 16px;
  }
`;

export const LandingPageWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1440px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 40px 40px;
  box-sizing: border-box;
  
  @media (max-width: 900px) {
    padding: 100px 30px 30px;
  }
  
  @media (max-width: 768px) {
    padding: 90px 24px 30px;
  }
  
  @media (max-width: 480px) {
    padding: 80px 20px 20px;
  }
  
  @media (max-width: 375px) {
    padding: 70px 16px 16px;
  }
`;

// Logo positioned at top left with responsive adjustments
export const Logo = styled.div`
  position: absolute;
  top: 50px;
  left: 50px;
  height: 32px;
  z-index: 2;
  
  img {
    height: 100%;
    width: auto;
    display: block;
    max-width: 136px;
  }
  
  @media (max-width: 900px) {
    left: 40px;
    top: 40px;
    height: 30px;
    
    img {
      max-width: 128px;
    }
  }
  
  @media (max-width: 768px) {
    top: 30px;
    left: 30px;
    height: 28px;
    
    img {
      max-width: 120px;
    }
  }
  
  @media (max-width: 480px) {
    top: 22px;
    left: 22px;
    height: 24px;
    
    img {
      max-width: 100px;
    }
  }
  
  @media (max-width: 375px) {
    top: 20px;
    left: 20px;
    height: 22px;
    
    img {
      max-width: 90px;
    }
  }
`;

export const ContentCard = styled(Card)`
  border-radius: 24px;
  border: 1px solid rgba(27, 16, 40, 0.1);
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.08);
  padding: 0;
  text-align: center;
  background: #fff;
  width: 100%;
  max-width: 920px;
  min-height: 460px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  box-sizing: border-box;
  
  .ant-card-body {
    padding: 48px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 460px;
    box-sizing: border-box;
  }
  
  @media (max-width: 900px) {
    max-width: calc(100% - 16px);
    
    .ant-card-body {
      padding: 40px 32px;
    }
  }
  
  @media (max-width: 768px) {
    border-radius: 20px;
    min-height: auto;
    max-width: calc(100% - 8px);
    
    .ant-card-body {
      padding: 32px 24px;
      min-height: auto;
    }
  }
  
  @media (max-width: 480px) {
    border-radius: 16px;
    max-width: 100%;
    
    .ant-card-body {
      padding: 28px 20px;
    }
  }
  
  @media (max-width: 375px) {
    border-radius: 14px;
    
    .ant-card-body {
      padding: 24px 16px;
    }
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  color: #2E45DA;
  margin-bottom: 20px;
  text-align: center;
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
  
  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 17px;
    margin-bottom: 14px;
  }
  
  @media (max-width: 375px) {
    font-size: 15px;
    margin-bottom: 12px;
  }
`;

export const MessageText = styled.div`
  font-size: 18px;
  line-height: 1.6;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  color: #2C2926;
  margin-bottom: 40px;
  text-align: center;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 660px;
  margin-left: auto;
  margin-right: auto;
  
  p {
    margin-bottom: 0;
  }
  
  @media (max-width: 768px) {
    font-size: 15px;
    margin-bottom: 28px;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 22px;
  }
  
  @media (max-width: 375px) {
    font-size: 12px;
    margin-bottom: 18px;
  }
`;

export const NextButton = styled(Button)`
  height: 48px;
  padding: 0 28px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  border-radius: 10px;
  background: #2E45DA !important;
  border-color: #2E45DA !important;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0 auto;
  transition: all 0.2s ease;
  
  svg {
    color: #fff !important;
    font-size: 16px;
  }
  
  &:hover,
  &:hover:not(:disabled) {
    background: #243AB8 !important;
    border-color: #243AB8 !important;
    color: #fff !important;
    
    svg {
      color: #fff !important;
    }
  }
  
  &:focus,
  &:focus:not(:disabled) {
    background: #2E45DA !important;
    border-color: #2E45DA !important;
    color: #fff !important;
    
    svg {
      color: #fff !important;
    }
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    height: 44px;
    font-size: 15px;
    padding: 0 24px;
    
    svg {
      font-size: 15px;
    }
  }
  
  @media (max-width: 480px) {
    height: 40px;
    font-size: 13px;
    padding: 0 18px;
    gap: 8px;
    border-radius: 8px;
    
    svg {
      font-size: 13px;
    }
  }
  
  @media (max-width: 375px) {
    height: 36px;
    font-size: 12px;
    padding: 0 14px;
    gap: 6px;
    
    svg {
      font-size: 12px;
    }
  }
`;

export const ProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
  
  @media (max-width: 375px) {
    margin-bottom: 16px;
  }
`;

export const AIIcon = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    margin-bottom: 14px;
  }

  @media (max-width: 480px) {
    width: 56px;
    height: 56px;
    margin-bottom: 12px;
  }

  @media (max-width: 375px) {
    width: 48px;
    height: 48px;
    margin-bottom: 10px;
  }
`;

export const AIText = styled.div`
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ProfileName = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #262626;
  font-family: 'Montserrat', sans-serif;
  word-wrap: break-word;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 15px;
  }
  
  @media (max-width: 375px) {
    font-size: 13px;
  }
`;

export const InstructionsText = styled.div`
  font-size: 16px;
  color: #595959;
  margin-bottom: 32px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 24px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 375px) {
    font-size: 11px;
    margin-bottom: 16px;
  }
`;

export const CallOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 24px;
  align-items: stretch;
  margin-bottom: 32px;
  width: 100%;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 24px;
  }
  
  @media (max-width: 480px) {
    gap: 14px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 375px) {
    gap: 10px;
    margin-bottom: 16px;
  }
`;

export const PhoneCallSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #f8f7fa;
  border-radius: 12px;
  border: 1px solid rgba(27, 16, 40, 0.1);
  
  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 14px;
    border-radius: 8px;
  }
  
  @media (max-width: 375px) {
    padding: 10px;
    border-radius: 6px;
  }
`;

export const CityButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
  }
  
  @media (max-width: 375px) {
    gap: 6px;
  }
`;

export const CityButton = styled(Button)`
  width: 100%;
  height: 56px;
  text-align: left;
  font-size: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  background: #fff;
  border: 1px solid rgba(27, 16, 40, 0.1);
  color: #262626;
  font-family: 'Montserrat', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  &:hover {
    border-color: #2E45DA;
    color: #2E45DA;
  }
  
  .anticon {
    color: #2E45DA;
    font-size: 18px;
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    height: 50px;
    font-size: 14px;
    gap: 10px;
    border-radius: 10px;
    
    .anticon {
      font-size: 16px;
    }
  }
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 12px;
    gap: 8px;
    padding: 0 12px;
    border-radius: 8px;
    
    .anticon {
      font-size: 14px;
    }
  }
  
  @media (max-width: 375px) {
    height: 38px;
    font-size: 11px;
    gap: 6px;
    padding: 0 10px;
    border-radius: 6px;
    
    .anticon {
      font-size: 12px;
    }
  }
`;

export const PinSection = styled.div`
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(27, 16, 40, 0.1);
  
  @media (max-width: 768px) {
    margin-bottom: 24px;
    padding-bottom: 24px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
  
  @media (max-width: 375px) {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }
`;

export const PinLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 20px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 14px;
  }
  
  @media (max-width: 375px) {
    font-size: 11px;
    margin-bottom: 10px;
  }
`;

export const PinBoxGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
  }
  
  @media (max-width: 375px) {
    gap: 5px;
  }
`;

export const PinBox = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(27, 16, 40, 0.1);
  border-radius: 12px;
  font-size: 24px;
  font-weight: 700;
  color: #2E45DA;
  font-family: 'Montserrat', sans-serif;
  
  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 20px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    font-size: 16px;
    border-radius: 8px;
  }
  
  @media (max-width: 375px) {
    width: 34px;
    height: 34px;
    font-size: 14px;
    border-radius: 6px;
  }
`;

export const WebCallSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8f7fa;
  border-radius: 12px;
  border: 1px solid rgba(27, 16, 40, 0.1);
  
  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 14px;
    border-radius: 8px;
  }
  
  @media (max-width: 375px) {
    padding: 10px;
    border-radius: 6px;
  }
`;

export const WebCallTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 8px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  @media (max-width: 375px) {
    font-size: 11px;
    margin-bottom: 4px;
  }
`;

export const WebCallSubtitle = styled.div`
  font-size: 14px;
  color: #595959;
  margin-bottom: 24px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 11px;
    margin-bottom: 14px;
  }
  
  @media (max-width: 375px) {
    font-size: 10px;
    margin-bottom: 10px;
  }
`;

export const WebCallButton = styled(Button)`
  width: 100%;
  max-width: 300px;
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0 auto;
  transition: all 0.2s ease;

  &.start-call {
    background: #2E45DA !important;
    border-color: #2E45DA !important;
    color: #fff !important;

    &:hover:not(:disabled) {
      background: #243AB8 !important;
      border-color: #243AB8 !important;
    }
  }

  &.end-call {
    background: #ef4444 !important;
    border-color: #ef4444 !important;
    color: #fff !important;

    &:hover:not(:disabled) {
      background: #dc2626 !important;
      border-color: #dc2626 !important;
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .anticon {
    font-size: 20px;
  }
  
  @media (max-width: 768px) {
    height: 50px;
    font-size: 14px;
    gap: 10px;
    border-radius: 10px;
    max-width: 260px;
    
    .anticon {
      font-size: 18px;
    }
  }
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 12px;
    gap: 8px;
    border-radius: 8px;
    max-width: 220px;
    
    .anticon {
      font-size: 16px;
    }
  }
  
  @media (max-width: 375px) {
    height: 38px;
    font-size: 11px;
    gap: 6px;
    border-radius: 6px;
    max-width: 180px;
    
    .anticon {
      font-size: 14px;
    }
  }
`;

export const CallStatusIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  color: ${props => {
    switch (props.$status) {
      case 'connecting': return '#f59e0b';
      case 'connected': return '#22c55e';
      case 'disconnected': return '#6b7280';
      default: return '#6b7280';
    }
  }};

  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${props => {
      switch (props.$status) {
        case 'connecting': return '#f59e0b';
        case 'connected': return '#22c55e';
        case 'disconnected': return '#6b7280';
        default: return '#6b7280';
      }
    }};
    ${props => props.$status === 'connecting' && `
      animation: pulse 1.5s ease-in-out infinite;
    `}
    ${props => props.$status === 'connected' && `
      animation: pulse 2s ease-in-out infinite;
    `}
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;

  span {
    font-size: 14px;
    color: #8c8c8c;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    text-transform: uppercase;
  }

  @media (max-width: 900px) {
    padding: 0;

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: rgba(27, 16, 40, 0.1);
    }

    span {
      padding: 0 16px;
    }
  }
`;

// ─── Active Call UI ───────────────────────────────────────────────

export const ActiveCallCard = styled(Card)`
  border-radius: 24px;
  border: 1px solid rgba(27, 16, 40, 0.1);
  box-shadow: 0px 0.75px 3.63px rgba(89, 108, 148, 0.04), 0px 6px 29px rgba(89, 108, 148, 0.07);
  padding: 0;
  background: #fff;
  width: 100%;
  max-width: 1000px;
  overflow: hidden;
  margin: 0 auto;

  .ant-card-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 700px;
    /* While media shows, grow by up to the note's height so the note doesn't shrink
       the media - only as far as keeps the buttons on screen. Browsers without svh
       keep the base height. */
    ${props => props.$withMedia && 'height: clamp(700px, calc(100svh - 85px), 742px);'}
  }

  @media (max-width: 768px) {
    border-radius: 20px;
    max-width: calc(100% - 8px);

    .ant-card-body {
      height: 560px;
      ${props => props.$withMedia && 'height: clamp(560px, calc(100svh - 83px), 600px);'}
    }
  }

  @media (max-width: 480px) {
    border-radius: 16px;
    max-width: 100%;

    .ant-card-body {
      height: 460px;
      ${props => props.$withMedia && 'height: clamp(460px, calc(100svh - 77px), 514px);'}
    }
  }
`;

export const CallHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 32px;
  background: linear-gradient(to right, rgba(46, 69, 218, 0.05), rgba(255, 255, 255, 0.05));
  border-bottom: 1px solid #E8E7E9;
  border-radius: 24px 24px 0 0;

  @media (max-width: 768px) {
    padding: 16px 20px;
    gap: 12px;
    border-radius: 20px 20px 0 0;
  }

  /* Must match CallPinBadge's stacked breakpoint - its flex-basis:100% needs a wrapping row. */
  @media (max-width: 660px) {
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
    gap: 10px;
    flex-wrap: wrap;
  }
`;

export const CallAvatar = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
`;

export const CallHeaderInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CallStudyName = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
  color: #2E45DA;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const CallPinText = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #6A7282;
  letter-spacing: -0.15px;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

/* Participants read this PIN aloud to the agent, so during a live call it has to stay legible -
   as a 14px grey subtitle under the study name it was the smallest thing on screen. Figma
   (node 6729-11535) promotes it to a bordered pill in the middle of the header. Colours sampled
   from that frame: #FFFFFF fill, #D8D8D8 border, #0A1B39 text. */
export const CallPinBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 0 0 auto;
  padding: 12px 24px;
  background: #FFFFFF;
  border: 1px solid #D8D8D8;
  /* Figma's corner radius measures ~28px on a 60px-tall pill, i.e. fully rounded. */
  border-radius: 999px;
  white-space: nowrap;
  /* explicit so the full-width phone row cannot overflow the header's padding */
  box-sizing: border-box;
  max-width: 100%;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: #0A1B39;

  .pin-digits {
    letter-spacing: 4px;
  }

  /* 860, not 768: measured, the study name starts truncating around 780px while the pill is
     still at its 24px desktop size. Stepping down earlier hands that width back to the name. */
  @media (max-width: 860px) {
    padding: 10px 18px;
    font-size: 20px;
    line-height: 26px;

    .pin-digits {
      letter-spacing: 3px;
    }
  }

  /* Below ~660px three across stops fitting and the name collapses to "New ..." (measured).
     Shrinking the PIN is the one thing we must not do, so the pill takes its own full-width row. */
  @media (max-width: 660px) {
    order: 3;
    flex-basis: 100%;
    padding: 10px 14px;
    font-size: 20px;
    line-height: 26px;

    .pin-digits {
      letter-spacing: 3px;
    }
  }

  /* Very narrow phones - ease off so the pill stops dominating the card. */
  @media (max-width: 360px) {
    padding: 8px 12px;
    font-size: 17px;
    line-height: 22px;

    .pin-digits {
      letter-spacing: 2px;
    }
  }
`;

/* Balances CallHeaderInfo (also flex:1) so the PIN pill sits centred between them, as in Figma.
   Hidden on phones: the Live Call badge is the least useful thing in this header (the running
   timer and the Hangup button already say the call is live), and dropping it hands the full row
   width back to the study name so it stops truncating to "New Study S...". Same 660px trigger as
   CallPinBadge's stacked row, so the two always change together. */
export const CallHeaderRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 660px) {
    display: none;
  }
`;

export const LiveBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: #DCFCE7;
  border-radius: 999px;
  white-space: nowrap;

  .live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #00A63E;
    opacity: 0.52;
    animation: livePulse 2s ease-in-out infinite;
  }

  .live-text {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #008236;
  }

  @keyframes livePulse {
    0%, 100% { opacity: 0.52; }
    50% { opacity: 1; }
  }

  @media (max-width: 480px) {
    padding: 3px 10px;

    .live-text {
      font-size: 12px;
    }
  }
`;

export const NoiseBubble = styled.div`
  /* Small pill floating in the empty gap just above the call buttons. Overlay
     only (absolute on ActionButtonsRow) so it never affects the card layout
     (no reflow, no scroll). No animation. Uses the page's red (#D94F4F, the
     Hangup-button red) with a light-red border, following the LiveBadge pill
     pattern. */
  position: absolute;
  bottom: calc(100% - 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  width: max-content;
  max-width: calc(100% - 40px);
  padding: 6px 14px;
  background: rgba(217, 79, 79, 0.08);
  border: 1px solid rgba(217, 79, 79, 0.30);
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(89, 108, 148, 0.10);
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  color: #D94F4F;

  .noise-dot {
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #D94F4F;
  }

  @media (max-width: 600px) {
    gap: 6px;
    font-size: 10px;
    line-height: 13px;
    padding: 4px 11px;
    white-space: normal;
    text-align: center;
    max-width: calc(100% - 20px);

    .noise-dot {
      width: 5px;
      height: 5px;
    }
  }
`;

export const CallContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 30px 40px 0;

  @media (max-width: 768px) {
    padding: 24px 20px 0;
  }

  @media (max-width: 480px) {
    padding: 16px 16px 0;
  }
`;

export const TimerDisplay = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 64px;
  line-height: 36px;
  color: #2C2926;
  margin-top: 70px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 48px;
    margin-top: 40px;
    margin-bottom: 28px;
  }

  @media (max-width: 480px) {
    font-size: 36px;
    margin-top: 28px;
    margin-bottom: 20px;
  }
`;

export const WaveformContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto 0;
  gap: 5px;
  width: 100%;
  max-width: 600px;
  height: 134px;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
    height: 90px;
    gap: 4px;
  }

  @media (max-width: 480px) {
    height: 50px;
    gap: 3px;

    & > div:nth-child(even) {
      display: none;
    }
  }
`;

export const WaveformBar = styled.div`
  width: 2px;
  min-width: 2px;
  border-radius: 1px;
  background: #2E45DA;
  height: ${props => `${Math.round((props.$height || 0.08) * 100)}%`};
  transition: height 0.06s linear;
  will-change: height;
`;

export const MediaDisplayArea = styled.div`
  width: 100%;
  max-width: ${props => props.$wide ? '100%' : '500px'};
  flex: 1;
  min-height: 0;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.$wide ? '#f5f4f8' : '#f5f4f7'};
  border: ${props => props.$wide ? '1px solid #e8e7e9' : 'none'};
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }

  video {
    max-width: 100%;
    max-height: 100%;
    display: block;
    background: #101828;
  }

  /* The expand button is the only full view: no browser fullscreen button. */
  video::-webkit-media-controls-fullscreen-button {
    display: none;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    background: #fff;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    border-radius: 10px;
  }
`;

// Shown over a media video that the browser started muted: one click turns the sound on.
export const MediaSoundButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border-radius: 8px;
  border: none;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  @media (max-width: 480px) {
    height: 28px;
    font-size: 12px;
    padding: 0 10px;
  }
`;

export const MediaExpandButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  z-index: 2;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.65);
  }

  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
    font-size: 12px;
    top: 8px;
    right: 8px;
  }
`;

export const MediaQuestionText = styled.div`
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  margin-top: 12px;
  flex-shrink: 0;

  .helper-text {
    font-weight: 600;
    font-size: 13px;
    line-height: 1.5;
    color: #2E45DA;
    background: rgba(46, 69, 218, 0.08);
    border-radius: 8px;
    padding: 8px 16px;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    .anticon {
      font-size: 14px;
    }
  }

  /* What the respondent can do with the media: replay / seek, ask to see it again. */
  .media-tips {
    max-width: 500px;
    margin: 6px auto 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.5;
    color: #5a6470;
    text-wrap: balance;
  }

  @media (max-width: 768px) {
    margin-top: 10px;
    .helper-text { font-size: 12px; padding: 6px 12px; }
    .media-tips { font-size: 11px; }
  }

  @media (max-width: 480px) {
    margin-top: 8px;
    .helper-text { font-size: 11px; padding: 5px 10px; }
    .media-tips { font-size: 11px; margin-top: 4px; }
  }
`;

export const ActionButtonsRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-top: auto;
  padding: 30px 32px 32px;

  @media (max-width: 768px) {
    gap: 28px;
    padding: 28px 20px 24px;
  }

  @media (max-width: 480px) {
    gap: 20px;
    padding: 26px 16px 20px;
  }
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  @media (max-width: 480px) {
    gap: 4px;
  }
`;

export const ActionCircle = styled.button`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid rgba(27, 16, 40, 0.15);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #2E45DA;
  font-size: 24px;

  &:hover:not(:disabled) {
    background: rgba(46, 69, 218, 0.06);
    border-color: #2E45DA;
  }

  &:active:not(:disabled) {
    transform: scale(0.93);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &.muted {
    background: rgba(46, 69, 218, 0.1);
    border-color: #2E45DA;
    color: #2E45DA;
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    font-size: 20px;
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
    font-size: 18px;
  }
`;

export const ActionLabel = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.3;
  color: #2E45DA;
  margin-top: 8px;
  text-align: center;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

export const MutedBubble = styled.div`
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(46, 69, 218, 0.85);
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 2;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid rgba(46, 69, 218, 0.85);
  }

  @media (max-width: 480px) {
    font-size: 9px;
    padding: 2px 6px;
    top: -18px;
  }
`;
